import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 5,
  filterType: {
    startDate: "",
    endDate: "",
    relatedBranch: "",
    logType: "",
    relatedItem: null,
    relatedUnit: null,
  },
  keyword: "",
};

const stockHistorySlice = createSlice({
  name: "filterStockHistory",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSearch: (state, action) => {
      state.keyword = action.payload;
    },
    setFilter: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    resetAll: (state) => {
      state.page = 1;
      state.limit = 5;
      state.keyword = "";
      state.filterType = {
        startDate: "",
        endDate: "",
        relatedBranch: "",
        logType: "",
        relatedItem: null,
        relatedUnit: null,
      };
    },
  },
});

export const { setPage, setLimit, setSearch, resetAll, setFilter } =
  stockHistorySlice.actions;
export default stockHistorySlice.reducer;
